/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React, { memo } from 'react'
import { Field } from 'formik'
import FormControlRadio from '../FormControlRadio'
import { areEqual } from './utils'

const withFieldRadio = (Input) => {
  const FieldComponent = props => <FormControlRadio {...props} customComponent={Input} />
  const component = memo(FieldComponent, areEqual)

  return props => <Field {...props} component={component} />
}

export default withFieldRadio
